"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PHONE_FR_VALUE = exports.PHONE_INTERNATIONAL_VALUE = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _libphonenumberJs = require("libphonenumber-js");

var moment = _interopRequireWildcard(require("moment-timezone"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _reactReduxI18n = require("react-redux-i18n");

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _validators = require("../utils/validators");

var _CountryFlag = _interopRequireDefault(require("./CountryFlag"));

var _country = require("../utils/country");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PHONE_INTERNATIONAL_VALUE = 'INTERNATIONAL';
exports.PHONE_INTERNATIONAL_VALUE = PHONE_INTERNATIONAL_VALUE;

var ALL_COUNTRIES_CODE = _country.ALL_COUNTRIES.map(function (country) {
  return _country.COUNTRY_CODE[country] ? _country.COUNTRY_CODE[country].toUpperCase() : null;
}).filter(function (countryCode) {
  return countryCode;
});

var PHONE_FR_VALUE = _country.COUNTRY_CODE.FRANCE.toUpperCase();

exports.PHONE_FR_VALUE = PHONE_FR_VALUE;
var FlagInput = (0, _core.withStyles)(function () {
  return {};
})(_core.InputBase);

function TextPhoneNumber(props) {
  function isInternational(value) {
    return !ALL_COUNTRIES_CODE.includes(value);
  }

  var initialState;

  if (props.value) {
    initialState = (0, _libphonenumberJs.parsePhoneNumberFromString)(props.value);
  }

  var initialCountry = props.defaultLocal;

  if (initialState && initialState.country) {
    initialCountry = initialState.country;
  }

  initialCountry = initialCountry.toUpperCase();
  var initialValue = isInternational(initialCountry) ? '+' : '';

  if (initialState) {
    if (initialCountry === PHONE_FR_VALUE) {
      initialValue = '0';
    }

    initialValue += initialState.nationalNumber;
  }

  var _React$useState = _react.default.useState(initialValue),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      phoneText = _React$useState2[0],
      setPhoneText = _React$useState2[1];

  var _React$useState3 = _react.default.useState(initialCountry),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      country = _React$useState4[0],
      setCountry = _React$useState4[1];

  var phoneNumberFieldInput = (0, _react.useRef)();

  function getMask() {
    return isInternational(country) ? _validators.PHONE_NUMBER_INTERNATIONAL_REGEX : _validators.PHONE_NUMBER_DEFAULT_REGEX;
  }

  var mask = getMask();

  function getPhoneObject(value) {
    if (value.startsWith('+')) {
      return (0, _libphonenumberJs.parsePhoneNumberFromString)(value);
    }

    return (0, _libphonenumberJs.parsePhoneNumberFromString)(value, country);
  }

  function constructEvent(value) {
    return {
      target: {
        value: value,
        type: 'phone'
      }
    };
  }

  function updateValue(rawValue) {
    function getCleanValue() {
      var value = rawValue;

      if (value.length > 0) {
        value = value.replace(/ /g, '').replace(/-/g, '').replace(/\)/g, '').replace(/\(/g, '');
      }

      return value;
    }

    var value = getCleanValue(rawValue);

    if (!mask.test(value)) {
      return;
    }

    var phoneObject = getPhoneObject(value);

    if (phoneObject && phoneObject.country !== country) {
      setCountry(phoneObject.country);
    }

    setPhoneText(value);
    var valueFormatted = value === '+' ? '' : value;
    props.onChange(constructEvent(phoneObject ? phoneObject.number : valueFormatted));
  } // Detect changes, but produced side effect of controlled component... still.. it works.


  _react.default.useEffect(function () {
    if (props.value) {
      updateValue(props.value);
    } // eslint-disable-next-line

  }, [props.value]);

  var handleChange = function handleChange(event) {
    event.preventDefault();
    event.stopPropagation();
    updateValue(event.target.value);
  };

  function getCountryFlag() {
    return isInternational(country) ? PHONE_INTERNATIONAL_VALUE : country;
  }

  function handleChangeFlag(event) {
    var countryKey = event.target.value;
    var value = isInternational(countryKey) ? PHONE_INTERNATIONAL_VALUE : countryKey; // Setting the focus to the number input field

    setTimeout(function () {
      return phoneNumberFieldInput.current.focus();
    }, 0);

    if (value === country) {
      return;
    }

    setCountry(value);
    setPhoneText(countryKey === PHONE_INTERNATIONAL_VALUE ? '+' : '');
    props.onChange(constructEvent(''));
  }

  function getFlag(key) {
    var big = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return key === PHONE_INTERNATIONAL_VALUE ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: "sphere",
      size: big ? 18 : 16
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
      countryCode: key.toLowerCase(),
      size: big ? 17 : 12
    });
  }

  var countries = ALL_COUNTRIES_CODE.concat(PHONE_INTERNATIONAL_VALUE).sort(function (countryCode, previousCountryCode) {
    return _reactReduxI18n.I18n.t("country.flags.".concat(countryCode)).localeCompare(_reactReduxI18n.I18n.t("country.flags.".concat(previousCountryCode)), props.currentLocale, {
      ignorePunctuation: true
    });
  }).map(function (countryCode, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
      value: countryCode,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "inline-container",
        children: [getFlag(countryCode), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "ellipsis",
          style: {
            maxWidth: 200
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "country.flags.".concat(countryCode)
          })
        })]
      })
    }, index);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "inline-container",
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.TextField, {
      "data-id": "text-phone-number-input",
      value: phoneText,
      onChange: handleChange,
      error: props.error,
      label: props.label,
      disabled: props.disabled,
      helperText: props.helperText,
      inputRef: phoneNumberFieldInput,
      InputProps: {
        startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
          position: "start",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              maxWidth: 300
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl.default, {
              variant: "standard",
              disabled: props.disabled,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
                value: getCountryFlag(),
                onChange: handleChangeFlag,
                input: /*#__PURE__*/(0, _jsxRuntime.jsx)(FlagInput, {
                  id: "age-customized-input"
                }),
                renderValue: function renderValue() {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      height: 12
                    },
                    children: getFlag(getCountryFlag(), true)
                  });
                },
                children: countries
              })
            })
          })
        })
      }
    })
  });
}

TextPhoneNumber.defaultProps = {
  defaultLocal: moment.locale()
};
TextPhoneNumber.propTypes = {
  value: _propTypes.default.string.isRequired,
  defaultLocal: _propTypes.default.string,
  error: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  currentLocale: _propTypes.default.string.isRequired
};
var _default = TextPhoneNumber;
exports.default = _default;
//# sourceMappingURL=TextPhoneNumber.js.map